import { CREDIT_CARD } from './constants';
import BigNumber from "bignumber.js";
export const templater = (templateString, templateVars={}) => new Function("return `" + templateString.replace(/\$\{/g, '${this.') + "`;").call(templateVars)
// https://gist.github.com/kucukharf/677d8f21660efaa33f72
export const rate = function (periods, payment, present, future, type, guess) {
  guess = (guess === undefined) ? 0.01 : guess;
  future = (future === undefined) ? 0 : future;
  type = (type === undefined) ? 0 : type;

  // Set maximum epsilon for end of iteration
  var epsMax = 1e-10;

  // Set maximum number of iterations
  var iterMax = 10;

  // Implement Newton's method
  var y, y0, y1, x0, x1 = 0,
    f = 0,
    i = 0;
  var rate = guess;
  if (Math.abs(rate) < epsMax) {
    y = present * (1 + periods * rate) + payment * (1 + rate * type) * periods + future;
  } else {
    f = Math.exp(periods * Math.log(1 + rate));
    y = present * f + payment * (1 / rate + type) * (f - 1) + future;
  }
  y0 = present + payment * periods + future;
  y1 = present * f + payment * (1 / rate + type) * (f - 1) + future;
  i = x0 = 0;
  x1 = rate;
  while ((Math.abs(y0 - y1) > epsMax) && (i < iterMax)) {
    rate = (y1 * x0 - y0 * x1) / (y1 - y0);
    x0 = x1;
    x1 = rate;
    if (Math.abs(rate) < epsMax) {
      y = present * (1 + periods * rate) + payment * (1 + rate * type) * periods + future;
    } else {
      f = Math.exp(periods * Math.log(1 + rate));
      y = present * f + payment * (1 / rate + type) * (f - 1) + future;
    }
    y0 = y1;
    y1 = y;
    ++i;
  }
  return rate;
};
// credit: http://stackoverflow.com/questions/2094967/excel-pmt-function-in-js
export const pmt = function (rate_per_period, number_of_payments, present_value, future_value, type) {
  future_value = typeof future_value !== 'undefined' ? future_value : 0;
  type = typeof type !== 'undefined' ? type : 0;

  if (rate_per_period != 0.0) {
    // Interest rate exists
    var q = Math.pow(1 + rate_per_period, number_of_payments);
    return -(rate_per_period * (future_value + (q * present_value))) / ((-1 + q) * (1 + rate_per_period * (type)));

  } else if (number_of_payments != 0.0) {
    // No interest rate, but number of payments exists
    return -(future_value + present_value) / number_of_payments;
  }

  return 0;
}

const bigMax = (bigNumbers)=>{
  if(!(bigNumbers instanceof Array))
    throw new Error('not an array')
  return bigNumbers.reduce((s, n)=>{
    if(s.isGreaterThan(n))
      return s;
    return n;
  }, bigNumbers[0])
}
export const calculateWithReducingBalance = (loanAmount, irr, repaymentRate, minRepayment = CREDIT_CARD.MIN_PAY_AMOUNT) => {
  BigNumber.set({ DECIMAL_PLACES: 10, ROUNDING_MODE: 6 })
  let irrInMonth = new BigNumber(irr).dividedBy(12)
  let outstanding = new BigNumber(loanAmount).plus(new BigNumber(loanAmount).times(irrInMonth))
  let bigRepaymentRate = new BigNumber(repaymentRate)
  let bigMinRepayment = new BigNumber(minRepayment)
  let interests = [irrInMonth.times(loanAmount)]
  let cashFlow = []
  while (true) {
    if(outstanding.isLessThanOrEqualTo(0) || cashFlow.length> 1000)
      break;
    let interestAccrued = outstanding.times(irrInMonth)
    interests.push(interestAccrued)
    let repayment = interestAccrued.plus(outstanding);
    let maxRepayment = bigMax([outstanding.times(bigRepaymentRate), bigMinRepayment])
    if (repayment.isGreaterThan(maxRepayment))
      repayment = maxRepayment
    outstanding = outstanding.minus(repayment).plus(interestAccrued)
    cashFlow.push(repayment)
  }
  const totalInterestPaid = Math.round(bigSum(interests))
  const installment = Math.round(bigSum(cashFlow.slice(0, 12)).dividedBy(12))
  return {
    tenor: cashFlow.length, installment, totalInterestPaid
  }
}

export const roundTo = (i, dp = 2) => (parseFloat(i.toFixed(dp)))
export const sum = (arr) => arr.reduce((s, n) => s + n)
export const bigSum = (arr) => arr.reduce((s, n) => s.plus(n), new BigNumber(0))
export const formatter = (format, v, unit=null) => {
  switch (format) {
    case 'currency':
      return "HKD " + new Intl.NumberFormat('zh-HK', { maximumSignificantDigits: 9 }).format(v.toFixed());
    case 'currency_short':
      return new Intl.NumberFormat('en-US', { maximumSignificantDigits: 9 }).format(v.toFixed());
    case 'tenor_short':
      return `${v}${unit}`
    case 'tenor_long':
      return `${v} months`
    case 'percentage':
      return `${(parseFloat(v)*100).toFixed()}%`
  }
}
